<template>
  <vue-final-modal
    :value="value"
    :name="name"
    :classes="['rirekisho-prime-upsell-dialog__container']"
    :content-class="[
      'rirekisho-prime-upsell-dialog__content',
      'v--modal-box',
      'v--modal',
      'prime-modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="$emit('input', $event)"
    @opened="onOpened"
  >
    <div class="v--modal-close-top">
      <el-button
        icon="el-icon-close"
        type="text"
        @click="$emit('input', false)"
      />
    </div>
    <div class="prime-modal-content">
      <div class="mypr-title-block">
        <p class="mypr-title-catch">ヤギプライム限定</p>
        <h3 class="prime-modal-title">ヤギプライムはメェっちゃ便利！</h3>
        <p class="prime-modal-lead">
          志望動機・自己PRでAI文章作成を使うと、<br />納得がいく自分だけの文章を作ることができます<br />その上、他にも便利な機能が！
        </p>
      </div>
      <div class="prime-modal-image">
        <img
          src="/static/renew2_img/prime-servicelist.png"
          alt="ヤギプライムサービス一覧"
        />
      </div>
      <p class="prime-modal-note">
        ※どのタイミングでも課金・退会していただくことが<br />できるので、安心してご利用いただけます。
      </p>
      <div class="prime-modal-buttons">
        <button class="prime-modal-cv-btn" @click="onJoin">
          ヤギプライムに加入する
        </button>
        <a href="/yagiprimeinfo" target="_blank" class="prime-modal-detail-btn"
          >より詳しく説明を見る</a
        >
      </div>
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
import { nextTick } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'

defineProps<{
  value: boolean
  name: string
}>()

const emit = defineEmits<{
  (e: 'input', value: boolean): void
}>()

const { vm, yagiprimePaymentService } = useHostServices()

function onOpened() {
  nextTick(() => {
    document
      .querySelectorAll('.rirekisho-prime-upsell-dialog__container')
      .forEach((el) => {
        ;(el as HTMLElement).scrollTop = 0
      })
  })
}

function onJoin() {
  emit('input', false)
  yagiprimePaymentService.useFeature(vm, 'prime-recommend', {
    onSuccess: () => {},
    onCancel: () => {}
  })
}
</script>

<style lang="scss">
@import '@/assets/scss/format-edit/vfm-attach-body-fixed';
@include vfm-root-fixed-when-has('.rirekisho-prime-upsell-dialog__container');

.rirekisho-prime-upsell-dialog__container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.rirekisho-prime-upsell-dialog__content.v--modal-box.v--modal {
  position: relative;
  box-sizing: border-box;
  flex: 0 1 auto;
  width: calc(100% - 40px);
  max-width: 400px;
  height: auto;
  margin: 0 auto;
  padding: 20px;
  border-radius: 8px;
  left: 0 !important;
}

.rirekisho-prime-upsell-dialog__content .v--modal-close-top {
  text-align: right;
}

.rirekisho-prime-upsell-dialog__content .prime-modal-content {
  text-align: center;
}

.rirekisho-prime-upsell-dialog__content .mypr-title-block {
  margin-bottom: 20px;
}

.rirekisho-prime-upsell-dialog__content .mypr-title-catch {
  position: relative;
  top: -25px;
  font-weight: bold;
  font-size: 10px;
  color: #fff;
  background: #ff8c00;
  padding: 3px 10px;
  border-radius: 30px;
  float: left;
}

.rirekisho-prime-upsell-dialog__content .prime-modal-title {
  clear: both;
  color: #004d40;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  line-height: 1.4;
  margin-bottom: 10px;
  margin-top: -10px;
}

.rirekisho-prime-upsell-dialog__content .prime-modal-lead {
  font-size: 13px;
  line-height: 1.6;
  text-align: center;
}

.rirekisho-prime-upsell-dialog__content .prime-modal-image {
  width: 100%;
  border-radius: 8px;
  margin: 15px 0;
}

.rirekisho-prime-upsell-dialog__content .prime-modal-image img {
  width: 80%;
  border-radius: 8px;
}

.rirekisho-prime-upsell-dialog__content .prime-modal-note {
  font-size: 10px;
  color: #666;
  line-height: 1.6;
  text-align: center;
  margin-bottom: 20px;
}

.rirekisho-prime-upsell-dialog__content .prime-modal-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.rirekisho-prime-upsell-dialog__content .prime-modal-cv-btn,
.rirekisho-prime-upsell-dialog__content .prime-modal-detail-btn {
  width: 100%;
  max-width: 300px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  line-height: 1.4;
  box-sizing: border-box;
}

.rirekisho-prime-upsell-dialog__content .prime-modal-cv-btn {
  background: #e3165c;
  color: #fff;
  border: none;
}

.rirekisho-prime-upsell-dialog__content .prime-modal-detail-btn {
  background: #fff;
  color: #e3165c;
  border: 1px solid #e3165c;
  text-decoration: none;
  text-align: center;
  display: inline-block;
}
</style>
